import { render, staticRenderFns } from "./StaticReportIcon.vue?vue&type=template&id=13e2342c&scoped=true"
import script from "./StaticReportIcon.vue?vue&type=script&lang=js"
export * from "./StaticReportIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e2342c",
  null
  
)

export default component.exports